export default "__VITE_ASSET__CXXMoXSK__"